import util from "@/util";

function format(value) {
  if (value < 9.95) return Math.floor(value * 10 + 0.5) / 10;
  return Math.floor(value + 0.5);
}

export default {
  namespaced: true,
  state: {
    amount: 10,
    effect: `TBD`,
    unitIndex: [
      {
        unit: "fl oz",
        oz(amount) {
          return amount;
        },
      },
      {
        unit: "oz",
        oz(amount) {
          return amount;
        },
      },
      {
        unit: "lbs",
        oz(amount) {
          return amount;
        },
      },
    ],
    unitIndices: {
      "U.S.": [
        {
          unit: "fl oz",
          oz(amount) {
            return amount;
          },
        },
        {
          unit: "oz",
          oz(amount) {
            return amount;
          },
        },
        {
          unit: "lbs",
          oz(amount) {
            return amount;
          },
        },
      ],
      Metric: [
        {
          unit: "ml",
          oz(amount) {
            return amount * 0.033814;
          },
        },
        {
          unit: "g",
          oz(amount) {
            return amount * 0.035274;
          },
        },
        {
          unit: "kg",
          oz(amount) {
            return amount * 2.20462;
          },
        },
      ],
      Imperial: [
        {
          unit: "fl oz",
          oz(amount) {
            return amount * 0.96076;
          },
        },
        {
          unit: "oz",
          oz(amount) {
            return amount;
          },
        },
        {
          unit: "lbs",
          oz(amount) {
            return amount;
          },
        },
      ],
    },
    chemical: {
      name: "6% bleach",
      unitIndex: 0,
      effects(oz, gallons) {
        const temp = oz * (600 / 825) * 0.84867552 * (100 / 125);
        const fc = format((temp / gallons) * 976.562);
        const salt = format((temp / gallons) * 1607);
        return ` raise FC by ${fc} and raise Salt by ${salt}`;
      },
    },
    chemicals: [
      {
        name: "5.25% bleach",
        unitIndex: 0,
        effects(oz, gallons) {
          const temp =
            oz * (525 / 600) * (600 / 825) * 0.84867552 * (100 / 125);
          const fc = format((temp / gallons) * 976.562);
          const salt = format((temp / gallons) * 1607);
          return ` raise FC by ${fc} and raise Salt by ${salt}`;
        },
      },
      {
        name: "6% bleach",
        unitIndex: 0,
        effects(oz, gallons) {
          const temp = oz * (600 / 825) * 0.84867552 * (100 / 125);
          const fc = format((temp / gallons) * 976.562);
          const salt = format((temp / gallons) * 1607);
          return ` raise FC by ${fc} and raise Salt by ${salt}`;
        },
      },
      {
        name: "8.25% bleach",
        unitIndex: 0,
        effects(oz, gallons) {
          const temp = (oz * 0.84867552 * (100 / 125)) / gallons;
          const fc = format(temp * 976.562);
          const salt = format((temp / gallons) * 1607);
          return ` raise FC by ${fc} and raise Salt by ${salt}`;
        },
      },
      {
        name: "10% bleach",
        unitIndex: 0,
        effects(oz, gallons) {
          const fc = format(((oz * (100 / 125)) / gallons) * 976.562);
          const salt = format(((oz * (100 / 125)) / gallons) * 1607);
          return ` raise FC by ${fc} and raise Salt by ${salt}`;
        },
      },
      {
        name: "12.5% bleach",
        unitIndex: 0,
        effects(oz, gallons) {
          const fc = format((oz / gallons) * 976.562);
          const salt = format((oz / gallons) * 1607);
          return ` raise FC by ${fc} and raise Salt by ${salt}`;
        },
      },
      {
        name: "trichlor",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format((oz / gallons) * 6854.95);
          const cya = format((oz / gallons) * 4159.41);
          const ph = Math.floor((oz / gallons) * 367 * 100 + 0.5) / 100;
          const salt = format((oz / gallons) * 5600);
          return ` raise FC by ${fc}, raise CYA by ${cya}, lower pH by ${ph}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "dichlor",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format((oz / gallons) * 4149.03);
          const cya = format((oz / gallons) * 3776.46);
          const ph = Math.floor((oz / gallons) * 158 * 100 + 0.5) / 100;
          const salt = format((oz / gallons) * 3384);
          return ` raise FC by ${fc}, raise CYA by ${cya}, lower pH by ${ph}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "48% cal-hypo",
        unitIndex: 1,
        effects(oz, gallons) {
          const temp = (oz * (48 / 53) * (53 / 65) * (65 / 73)) / gallons;
          const fc = format(temp * 5422.41);
          const ch = format(temp * 3827.09);
          const salt = format(temp * 5500);
          return ` raise FC by ${fc}, raise CH by ${ch}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "53% cal-hypo",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format(((oz * (53 / 65) * (65 / 73)) / gallons) * 5422.41);
          const ch = format(((oz * (53 / 65) * (65 / 73)) / gallons) * 3827.09);
          const salt = format(((oz * (53 / 65) * (65 / 73)) / gallons) * 5500);
          return ` raise FC by ${fc}, raise CH by ${ch}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "65% cal-hypo",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format(((oz * (65 / 73)) / gallons) * 5422.41);
          const ch = format(((oz * (65 / 73)) / gallons) * 3827.09);
          const salt = format(((oz * (65 / 73)) / gallons) * 5500);
          return ` raise FC by ${fc}, raise CH by ${ch}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "73% cal-hypo",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format((oz / gallons) * 5422.41);
          const ch = format((oz / gallons) * 3827.09);
          const salt = format((oz / gallons) * 5500);
          return ` raise FC by ${fc}, raise CH by ${ch}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "lithium hypochlorite",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format((oz / gallons) * 2637.5);
          const salt = format((oz / gallons) * 4170);
          return ` raise FC by ${fc} and raise Salt by ${salt}`;
        },
      },
      {
        name: "chlorine gas",
        unitIndex: 1,
        effects(oz, gallons) {
          const fc = format((oz / gallons) * 7489.4);
          const ph = Math.floor((oz / gallons) * 625 * 100 + 0.5) / 100;
          const salt = format((oz / gallons) * 6140);
          return ` raise FC by ${fc}, lower pH by ${ph}, and raise Salt by ${salt}`;
        },
      },
      {
        name: "15.7% muriatic acid",
        unitIndex: 0,
        effects(oz, gallons) {
          const ph = Math.floor((oz / 2 / gallons) * 240.15 * 100 + 0.5) / 100;
          const ta = format((oz / 2 / gallons) * 3911.47);
          return ` lower pH by ${ph} and lower TA by ${ta}`;
        },
      },
      {
        name: "31.45% muriatic acid",
        unitIndex: 0,
        effects(oz, gallons) {
          const ph = Math.floor((oz / gallons) * 240.15 * 100 + 0.5) / 100;
          const ta = format((oz / gallons) * 3911.47);
          return ` lower pH by ${ph} and lower TA by ${ta}`;
        },
      },
      {
        name: "dry acid",
        unitIndex: 1,
        effects(oz, gallons) {
          const ph = Math.floor((oz / gallons) * 167.9 * 100 + 0.5) / 100;
          const ta = format((oz / gallons) * 2909.47);
          return ` lower pH by ${ph} and lower TA by ${ta}`;
        },
      },
      {
        name: "washing soda or soda ash",
        unitIndex: 1,
        effects(oz, gallons) {
          const ph = Math.floor((oz / gallons) * 217.1 * 100 + 0.5) / 100;
          const ta = format((oz / gallons) * 7072.46);
          return ` raise pH by ${ph} and raise TA by ${ta}`;
        },
      },
      {
        name: "borax (20 Mule Team)",
        unitIndex: 1,
        effects(oz, gallons) {
          const ph = Math.floor((oz / gallons) * 109.1 * 100 + 0.5) / 100;
          const borate = format((oz / gallons) * 849.271);
          const ta = format((oz / gallons) * 1949.93);
          return ` raise pH by ${ph}, raise Borate by ${borate}, and raise TA by ${ta}`;
        },
      },
      {
        name: "sodium tetraborate pentahydrate",
        unitIndex: 1,
        effects(oz, gallons) {
          const ph = Math.floor((oz / gallons) * 166.8 * 100 + 0.5) / 100;
          const borate = format((oz / gallons) * 1111.69);
          const ta = format((oz / gallons) * 2548.89);
          return ` raise pH by ${ph}, raise Borate by ${borate}, and raise TA by ${ta}`;
        },
      },
      {
        name: "boric acid",
        unitIndex: 1,
        effects(oz, gallons) {
          const borate = format((oz / gallons) * 1309.52);
          const ph = Math.floor((oz / gallons) * 7.559 * 100 + 0.5) / 100;
          return ` raise Borate by ${borate} and lower PH by ${ph}`;
        },
      },
      {
        name: "caustic soda (lye)",
        unitIndex: 1,
        effects(oz, gallons) {
          const ph = Math.floor((oz / gallons) * 546.3 * 100 + 0.5) / 100;
          const ta = format((oz / gallons) * 9135.78);
          return ` raise pH by ${ph} and raise TA by ${ta}`;
        },
      },
      {
        name: "baking soda",
        unitIndex: 1,
        effects(oz, gallons) {
          const ta = format((oz / gallons) * 4461.56);
          const ph = Math.floor((oz / gallons) * 9.091 * 100 + 0.5) / 100;
          return ` raise TA by ${ta} and raise pH by ${ph}`;
        },
      },
      {
        name: "calcium chloride",
        unitIndex: 1,
        effects(oz, gallons) {
          const ch = format((oz / gallons) * 6754.11);
          return ` raise CH by ${ch}`;
        },
      },
      {
        name: "calcium chloride dihydrate",
        unitIndex: 1,
        effects(oz, gallons) {
          const ch = format((oz / gallons) * 5098.82);
          return ` raise CH by ${ch}`;
        },
      },
      {
        name: "stabilizer",
        unitIndex: 1,
        effects(oz, gallons) {
          const cya = format((oz / gallons) * 7489.51);
          const ph = Math.floor((oz / gallons) * 138.8 * 100 + 0.5) / 100;
          return ` raise CYA by ${cya} and lower pH by ${ph}`;
        },
      },
      {
        name: "liquid stabilizer",
        unitIndex: 0,
        effects(oz, gallons) {
          const cya = format((oz / gallons) * 2890);
          return ` raise CYA by ${cya}`;
        },
      },
      {
        name: "salt",
        unitIndex: 2,
        effects(oz, gallons) {
          const salt = format((oz / gallons) * 7468.64 * 16);
          return ` raise Salt by ${salt}`;
        },
      },
    ],
  },
  getters: {
    getEffects(state) {
      return state;
    },
  },
  mutations: {
    calcEffects(state, settings) {
      const gallons = util.getGallons(settings.volume, settings.unitType);
      const units = state.unitIndex[state.chemical.unitIndex];
      const oz = units.oz(state.amount);
      const unit = units.unit;
      const effects = state.chemical.effects(oz, gallons);
      state.effect = `
        Adding ${state.amount} ${unit} 
        of ${state.chemical.name} 
        will ${effects}
      `;
    },
    setEffects(state, effects) {
      state = effects;
    },
  },
  actions: {},
};
